export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastify/node_modules/react-transition-group/esm/config.js
// module id = null
// module chunks = 